import { parsePartnerBirthDate } from "../features/couple-match/coupleMatchBazi.js";

export function isParsableBirthDate(isoDate) {
  return Boolean(parsePartnerBirthDate(isoDate));
}

export function validatePartnerBirthDates(partnerA, partnerB, messages = {}) {
  const a = partnerA?.birthDate;
  const b = partnerB?.birthDate;
  if (!a || !b) return messages.required || "required_dob";
  if (!isParsableBirthDate(a) || !isParsableBirthDate(b)) return messages.invalid || "invalid_dob";
  const today = new Date();
  const todayStart = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const aDate = new Date(`${a}T00:00:00`);
  const bDate = new Date(`${b}T00:00:00`);
  if (aDate > todayStart || bDate > todayStart) return messages.future || "future_dob";
  return "";
}
